import { BaseActionItemProps } from './ActionItemTypes';
import { ClassSummaryActionItem } from './ClassSummaryActionItem';
import { DraftMessageActionItem } from './DraftMessageActionItem';

export const ActionAccordionItem = ({
  type,
  title,
  studentVoiceName,
  actionId,
  message,
  date,
  periodId,
}: BaseActionItemProps & { periodId: string }) => {
  // Factory pattern - route to specific implementations
  switch (type) {
    case 'class_summary':
      return (
        <ClassSummaryActionItem
          title={title}
          type={type}
          actionId={actionId}
          message={message}
          date={date}
          periodId={periodId}
        />
      );

    case 'praised_students':
    case 'warned_students':
      return (
        <DraftMessageActionItem
          type={type}
          studentVoiceName={studentVoiceName}
          actionId={actionId}
          message={message}
          date={date}
        />
      );

    default:
      // Don't show anything for unknown types
      return <></>;
  }
};
